export default __webpack_public_path__ + "static/Rocket_Homing_Missile-9002162e870df1c886eca7b9acd55f01.png";